"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IFramePopover = exports.IFramePopoverWrapper = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var iframe_resizer_react_1 = __importDefault(require("iframe-resizer-react"));
var Spinner_1 = __importDefault(require("@rio-cloud/rio-uikit/lib/es/Spinner"));
var IFramePopoverWrapper = function (props) {
    var iFrameUrl = props.iFrameUrl, isLoading = props.isLoading, setIsLoading = props.setIsLoading, innerRef = props.innerRef, onMessage = props.onMessage;
    if (iFrameUrl) {
        return ((0, jsx_runtime_1.jsx)(exports.IFramePopover, { iFrameUrl: iFrameUrl, isLoading: isLoading, setIsLoading: setIsLoading, innerRef: innerRef, onMessage: onMessage }));
    }
    else {
        // local mock
        return ((0, jsx_runtime_1.jsx)("div", { ref: innerRef, children: (0, jsx_runtime_1.jsx)(iframe_resizer_react_1.default, { id: 'mock-iframe', className: 'margin-top--10 margin-bottom--20', style: { width: '1px', minWidth: '100%', border: '0' }, srcDoc: "<h4>Mocked Notifications</h4>" }) }));
    }
};
exports.IFramePopoverWrapper = IFramePopoverWrapper;
var IFramePopover = function (props) {
    var iFrameUrl = props.iFrameUrl, isLoading = props.isLoading, setIsLoading = props.setIsLoading, innerRef = props.innerRef, onMessage = props.onMessage;
    var onInit = function () {
        setIsLoading(false);
    };
    return ((0, jsx_runtime_1.jsxs)("div", { className: 'max-height-100vh-xs max-height-75vh overflow-auto', ref: innerRef, children: [isLoading && ((0, jsx_runtime_1.jsx)("div", { style: {
                    display: 'flex',
                    justifyContent: 'center',
                    height: '50px',
                    alignItems: 'flex-end',
                }, "data-testid": 'loading-spinner', children: (0, jsx_runtime_1.jsx)(Spinner_1.default, { isDoubleSized: true }) })), (0, jsx_runtime_1.jsx)(iframe_resizer_react_1.default, { id: 'platform-notification-iframe', src: iFrameUrl, minHeight: 42, checkOrigin: [iFrameUrl], onInit: onInit, onMessage: onMessage, heightCalculationMethod: 'lowestElement', style: {
                    width: '1px',
                    minWidth: '100%',
                    border: '0',
                } })] }));
};
exports.IFramePopover = IFramePopover;
